import { EventEmitter } from ".";

class GlobalEventEmitter {
  constructor() {
    this.emitter = new EventEmitter();
    this.emitter.setMaxListeners(5);
  }
  addEventListener(event, cb) {
    this.emitter.on(event, cb);
  }
  dispatchEvent(event, data) {
    if (!data["payload"]) throw new Error("Did not pass payload");
    this.emitter.emit(event, data["payload"]);
  }
  removeEventListener(event, cb) {
    this.emitter.removeListener(event, cb);
  }
}

// eslint-disable-next-line kf/const-naming-convention
export const GlobalEventManager = new GlobalEventEmitter();
